// removed by extract-text-webpack-plugin
module.exports = {"projectStatusIcon":"Project__projectStatusIcon___3rEP6","tooltip":"Project__tooltip___1aNQt","statusColumn":"Project__statusColumn___3o3BV"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/Project/components/Project.scss
// module id = 1220
// module chunks = 1